import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { fetchClientList } from '../modules/client'
import FormDialog from '../components/formDialog'
import Messages from '../constants/messages'
import {
  fetchPermissions,
  postPermission,
  putPermission,
  removePermission } from '../modules/permission'
import { paginationChangePage, paginationChangeRowsPerPage } from '../modules/table'
import { required } from '../utils/validationRules'
import { setFormValues, showDialog, resetForm, setConfirmationItem } from '../modules/formDialog'
import TableDisplay from '../components/tableDisplay'
import withStyles from 'material-ui/styles/withStyles'
import { unflagDataRefresh } from '../modules/refresh'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  permissions: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired
}

const styles = theme => ({
  root: {
    maxWidth: 955,
    margin: 'auto'
  },
  pageMessage: theme.pageMessage
})

export class Permissions extends Component {
  permissionTableOptions = [
    {
      name: 'name',
      friendlyName: Messages['uiComponents']['TABLE_NAME_COLUMN'],
      displayType: 'string'
    },
    {
      name: 'applicationId',
      friendlyName: Messages['uiComponents']['TABLE_APPLICATION_ID_COLUMN'],
      displayType: 'string'
    },
    {
      name: 'description',
      friendlyName: Messages['uiComponents']['TABLE_DESCRIPTION_COLUMN'],
      displayType: 'string'
    },
  ]

  tableButtons = [
    {
      buttonName: 'ModeEdit',
      callback: (permission) => {
        this.props.setFormValues(permission)
        this.props.showDialog(true, 'edit')
      },
      tooltip: Messages['tooltips']['EDIT']
    },
    {
      buttonName: 'Clear',
      callback: (permission) => {
        this.props.setConfirmationItem(permission)
        this.props.showDialog(true, 'delete')
      },
      tooltip: Messages['tooltips']['DELETE']
    }
  ]

  dialogOptions = {
    new: [
      {
        type: 'textField',
        name:'name',
        friendlyName: Messages['uiComponents']['PERMISSIONS_NAME_INPUT_FIELD'],
        validationRules: [required]
      },
      {
        type: 'textField',
        name:'description',
        friendlyName: Messages['uiComponents']['PERMISSIONS_DESCRIPTION_INPUT_FIELD'],
        validationRules: [required]
      }
    ],
    edit: [
      {
        type: 'textField',
        name:'name',
        friendlyName: Messages['uiComponents']['PERMISSIONS_NAME_INPUT_FIELD'],
        validationRules: [required]
      },
      {
        type: 'textField',
        name:'description',
        friendlyName: Messages['uiComponents']['PERMISSIONS_DESCRIPTION_INPUT_FIELD'],
        validationRules: [required]
      }
    ],
    delete: [
      {
        type: 'confirmation',
        name:'deletePermission',
        confirmationType: 'delete'
      }
    ]
  }

  getProgressIndicatorText(formType) {
    switch(formType) {
      case 'new':
        return Messages['uiComponents']['CREATING_MSG']
      case 'edit':
        return Messages['uiComponents']['UPDATING_MSG']
      case 'delete':
        return Messages['uiComponents']['DELETING_PERMISSION_MSG']
      default:
        return Messages['uiComponents']['LOADING_MSG']
    }
  }

  setTitle(formType) {
    switch(formType) {
      case 'new':
        return Messages['uiComponents']['CREATE_PERMISSION_TITLE']
      case 'edit':
        return Messages['uiComponents']['EDIT_PERMISSION_TITLE']
      case 'delete':
        return Messages['uiComponents']['DELETE_PERMISSION_TITLE']
      default:
        return ''
    }
  }

  componentWillMount() {
    const { clientList, dataRefreshRequired, fetchClientList, fetchPermissions, unflagDataRefresh } = this.props
    if (clientList.length === 0) {
      fetchClientList()
    }
    if (dataRefreshRequired) {
      unflagDataRefresh('permissions')
      fetchPermissions(true)
    }
  }

  handleSubmit(values) {
    const {
      applicationId,
      confirmationItem,
      formType,
      postPermission,
      putPermission,
      removePermission,
      resetForm } = this.props
    switch(formType) {
      case 'new':
        postPermission({...values, applicationId})
        resetForm()
        break
      case 'edit':
        putPermission({...values, applicationId})
        resetForm()
        break
      case 'delete':
        removePermission(confirmationItem)
        resetForm()
        break
      default:
        break
    }
  }

  render() {
    const {
      classes,
      clientList,
      confirmationItem,
      fetchPermissions,
      formValues,
      formType,
      isLoadingDialog,
      permissions,
      resetForm,
      paginationChangePage,
      paginationChangeRowsPerPage,
      paginationPage,
      paginationRowsPerPage,
      showDialog,
      open,
      roles,
      totalCount } = this.props

    return (
      <section className={classes.root}>
        <FormDialog
          buttonLabel={Messages['uiComponents']['CREATE_PERMISSION_BUTTON']}
          data={{clientList}}
          confirmationItem={confirmationItem}
          dialogOptions={this.dialogOptions[formType] || []}
          infoText={this.getProgressIndicatorText(formType)}
          initialValues={formValues}
          enableReinitialize={true}
          handleFormSubmit={(values) => this.handleSubmit(values)}
          isLoading={isLoadingDialog}
          open={open}
          showDialog={showDialog}
          resetFormValues={resetForm}
          title={this.setTitle(formType)} />
        <p className={classes.pageMessage}>{Messages['pageHeaders']['PERMISSIONS_PAGE_MSG']}</p>
        <TableDisplay
          data={permissions}
          fetchDataCallback={fetchPermissions}
          page={paginationPage}
          paginationChangePage={paginationChangePage}
          paginationChangeRowsPerPage={paginationChangeRowsPerPage}
          rowsPerPage={paginationRowsPerPage}
          serverSidePagination={true}
          tab="permission"
          tableOptions={this.permissionTableOptions}
          tableButtons={this.tableButtons}
          totalCount={totalCount}
          roles={roles}
          type="permission" />
      </section>
    )
  }
}

Permissions.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  applicationId: state.appContext.appInfo.id,
  clientList: state.client.clientList,
  confirmationItem: state.formDialog.confirmationItem,
  dataRefreshRequired: state.refresh.dataRefreshRequired.permissions,
  formType: state.formDialog.formType,
  formValues: state.formDialog.formValues,
  isLoadingDialog: state.loading.isLoadingDialog,
  open: state.formDialog.open,
  paginationPage: state.table.paginationPage.permission,
  paginationRowsPerPage: state.table.paginationRowsPerPage.permission,
  permissions: state.permission.permissions,
  roles: state.role.roles,
  totalCount: state.permission.totalCount
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchClientList,
  fetchPermissions,
  postPermission,
  putPermission,
  paginationChangePage,
  paginationChangeRowsPerPage,
  showDialog,
  setConfirmationItem,
  setFormValues,
  removePermission,
  resetForm,
  unflagDataRefresh
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Permissions)
